<template>
  <div class="artical_list">
    <section class="des-container">
      <template>
        <Price
          v-if="!articalObj.isFree && articalObj.isPay < 1"
          :number="articalObj.price"
        ></Price>
        <div @click.stop.prevent="collectClickFn" class="heart-warp">
          <div
            class="collect_blank collect_have"
            v-if="!yesAttentionFlag && !noAttentionFlag"
          ></div>
          <div class="collect_blank" v-if="yesAttentionFlag"></div>
          <div class="collect_blank collect_have" v-if="noAttentionFlag"></div>
          <p class="collect_word">收藏</p>
        </div>
        <div class="des-warp">
          <van-tag
            v-if="!articalObj.isFree && articalObj.isPay < 1"
            size="medium"
            color="#1A0801"
            text-color="#FFE499"
            >付费</van-tag
          >
          <span class="des-text">
            {{ articalObj.title }}
          </span>
        </div>
      </template>
      <div
        class="tag_area"
        v-if="articalObj.labels && articalObj.labels.length > 0"
      >
        <span
          class="tag_wrap"
          v-for="(item, index) in articalObj.labels"
          :key="index"
          >{{ item.label }}</span
        >
      </div>

      <div class="author-warp" v-if="articalObj.author">
        <div class="author-left">
          <div class="gray-circle"></div>
          <span class="author-name">{{ articalObj.author }}</span>
        </div>
        <span class="public-date">{{ getTime(articalObj.createTime) }}</span>
      </div>
    </section>

    <section class="artical-content">
      <div class="deatil-warp">
        <h2 class="deatil-title">文章内容：</h2>
        <div
          class="cover_area"
          :class="{ 'nopay-filter': !articalObj.isFree && !articalObj.isPay }"
          v-if="urlFlag"
        >
          <div class="img_wrap">
            <img :src="imgurl | addHost" alt="hi" />
          </div>
        </div>

        <div
          class="deatil-des"
          :class="{ 'nopay-filter': !articalObj.isFree && !articalObj.isPay }"
          v-html="articalObj.details"
        ></div>
      </div>
    </section>

    <section class="purchase-notes" v-if="!articalObj.isFree">
      <p class="purchase-notes-title">购买须知：</p>
      <p class="purchase-notes-des">
        知识店铺课程为付费课程的，按照课程计划定期更新，
        每节课可在开课时学习，也可反复回听，该课程听课权益跟随支付购买微信账号ID，
        不支持更换，线上课程为虚拟付费内容，一经订阅不可退费，
        转让，请您于购买时谨慎考虑，如您需要开票，请联系店铺申请开具发票。
        请联系店铺申请开具发票。该作品版权归原作者所有，禁止任何形式的商业使用（含翻录、传播等侵权行为），
        违反者将依法承担法律责任。
      </p>
    </section>
    <div class="footer-warp" v-if="!articalObj.isFree && articalObj.isPay < 1">
      <!-- <div @click.stop.prevent="collectClickFn" class="heart-warp">
        <div class="collect_blank" v-if="yesAttentionFlag"></div>
        <div class="collect_blank collect_have" v-if="noAttentionFlag"></div>
        收藏
      </div> -->
      <van-button round @click="buyAtOnce">{{ btnText }}</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  _userAttention,
  _julyAttention,
  _delAttention,
} from "../../api/parent-course";
import { decryptBy } from "../../assets/js/encryption";
import Price from "../price/price.vue";
import Template from "@/views/test-center/template.vue";

export default {
  name: "artical-list",
  components: { Price, Template },
  props: {
    showFirstContent: {
      type: Boolean,
      default: true,
    },
    articalObj: {
      type: Object,
      default: () => {
        return {
          title: "xxx",
        };
      },
    },
  },
  data() {
    return {
      noAttentionFlag: false, //用户否收藏的标志
      yesAttentionFlag: false, //用户否收藏的标志
      attentionParams: {
        contentId: "",
        cuserId: "",
      },
    };
  },
  watch: {
    articalObj(newval) {
      let id = newval.id;
      this.julyAttention({
        contentId: id,
      });
    },
  },
  computed: {
    imgurl() {
      if (this.articalObj.materialIdList) {
        const tempValue = JSON.parse(this.articalObj.materialIdList);
        console.log(tempValue);
        let host = location.host;
        // return 'http://' + host + '/' + val
        // return 'http://172.16.12.229:9100/' + tempValue[0].url
        return tempValue[0].url;
      }
    },
    urlFlag() {
      if (this.articalObj.materialIdList) {
        const temp = JSON.parse(this.articalObj.materialIdList);
        return temp[0].url ? true : false;
      }
    },
    btnText() {
      if (this.articalObj.isFree) {
        return "免费文章";
      } else {
        if (this.articalObj.isPay) {
          return "已购买";
        } else {
          return "立即购买￥" + this.articalObj.price;
        }
      }
    },
  },
  methods: {
    getTime(time) {
      if (time) {
        var timearr = time.split(" ");
        var timestr = timearr[0];
        return timestr;
      }
    },
    buyAtOnce() {
      if (
        (!this.articalObj.isFree && !this.articalObj.isPay) ||
        (this.articalObj.courseType && this.articalObj.courseType == 2)
      ) {
        localStorage.setItem("adress", "");
        sessionStorage.setItem("orderDetails", JSON.stringify(this.articalObj));
        if (this.articalObj.courseType && this.articalObj.courseType == 2) {
          //true 线下课程 false 线上课程
          this.$router.push("/outlineOrderConfirm");
        } else {
          this.$router.push("/orderConfirm");
        }
      }
    },
    collectClickFn() {
      this.attentionParams.contentId = this.articalObj.id;
      // 没有收藏，点击发送收藏
      if (this.noAttentionFlag) {
        // send收藏
        this.userAttention(this.attentionParams);
      } else if (this.yesAttentionFlag) {
        // 已经收藏，点击取消收藏
        this.delAttention(this.attentionParams);
      }
    },
    // 查询用户是否收藏
    async julyAttention(contentId) {
      try {
        let res = await _julyAttention(contentId);
        let { code, data, message } = res;
        if (res && code === 200) {
          if (data) {
            this.yesAttentionFlag = true;
            this.noAttentionFlag = false;
          } else {
            this.noAttentionFlag = true;
            this.yesAttentionFlag = false;
          }
        } else {
          Toast(message);
          this.noAttentionFlag = true;
          this.yesAttentionFlag = false;
        }
      } catch (error) {}
    },
    // 用户取消收藏
    async delAttention(delParams) {
      try {
        let res = await _delAttention(delParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          if (data) {
            this.noAttentionFlag = true;
            this.yesAttentionFlag = false;
            Toast("取消收藏");
          } else {
            this.noAttentionFlag = false;
            this.yesAttentionFlag = true;
          }
        } else {
          Toast(message);
          this.noAttentionFlag = false;
          this.yesAttentionFlag = true;
        }
        // 查询是否取消收藏成功
        this.julyAttention(this.attentionParams);
      } catch (error) {}
    },
    // 用户收藏
    async userAttention(attentionParams) {
      try {
        let res = await _userAttention(attentionParams);
        let { code, message, data } = res;
        if (res && code === 200) {
          if (data) {
            Toast("收藏成功");
          } else {
            Toast("收藏失败，请稍后尝试");
          }
        } else {
          Toast("收藏失败，请检查网络");
        }
        // 查询是否收藏成功
        this.julyAttention(this.attentionParams);
      } catch (error) {}
    },
  },
  beforeCreate() {},
  created() {
    // let id = this.articalObj.id
    // this.julyAttention({
    //   contentId: id
    // })
  },
  filters: {
    addHost: function (val) {
      let host = location.host;
      // return 'http://' + host + '/' + val
      // return 'http://172.16.12.104:8999/' + val
      return val;
    },
  },
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
$heart_have: "../../assets/images/parent-course/heart-bg.png";
$heart_blank: "../../assets/images/parent-course/heart_blank.png";
.artical_list {
  margin-top: 58px;

  section {
    padding: 6px 20px 12px 20px;
    background-color: #fff;
    margin-top: 8px;
  }
  .des-text {
    margin-left: 4px;
    font-size: 16px;
    color: #3c4130;
  }
  .heart-warp {
    padding: 4px, 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 10%;
    float: right;
    .collect_blank {
      width: 22px;
      height: 22px;
      background: url($heart_blank) no-repeat;
      background-size: contain;
    }
    .collect_word {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2e4344;
    }
    .collect_have {
      background: url($heart_have) no-repeat;
      background-size: contain;
    }
  }
  .des-container {
    padding: 6px 20px 12px 20px;
    background-color: #fff;
    float: left;
    width: 100%;
    .des-warp {
      margin-top: 6px;
      width: 80%;
      float: left;
      .van-tag {
        float: left;
        margin-top: 2px;
      }
    }

    .top-box {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }
    .tag_area {
      width: 100%;
      margin: 30px 0 0px;
      text-align: left;

      .tag_wrap {
        display: inline-block;
        min-width: 49px;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
        text-align: center;
        border-radius: 11px;
        margin: 6px;
        padding: 0 10px;
        &:nth-child(5n + 1) {
          background-color: rgba(255, 148, 134, 0.1);
          color: #f56444;
        }
        &:nth-child(5n + 2) {
          background-color: #fff3ea;
          color: #ff8340;
        }
        &:nth-child(5n + 3) {
          background-color: rgba(73, 204, 154, 0.1);
          color: #49cc9a;
        }
        &:nth-child(5n + 4) {
          background-color: rgba(37, 166, 249, 0.1);
          color: #25a6f9;
        }
        &:nth-child(5n + 5) {
          background-color: rgba(157, 154, 255, 0.1);
          color: #887df7;
        }
      }
    }
    .author-warp {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #606f71;
      float: left;
      width: 100%;
      .author-left {
        display: flex;
        align-items: center;
        .gray-circle {
          width: 16px;
          height: 16px;
          background: #c3cad6;
          border-radius: 999px;
        }
        .author-name {
          margin-left: 4px;
        }
      }
      .public-date {
        /* position: absolute; */
        right: 20px;
      }
    }
  }

  .artical-content {
    float: left;
    width: 100%;
    .deatil-warp {
      margin-top: 16px;
      .deatil-title {
        font-size: 16px;
        color: #3c4130;
        line-height: 1.2;
        font-weight: 500;
      }
      .cover_area {
        min-height: 196px;
        margin: 8px auto 0 auto;
        .img_wrap {
          width: 100%;
          min-height: 196px;
          img {
            height: 100%;
            width: 100%;
          }
        }
      }
      .deatil-des {
        margin-top: 8px;
        font-size: 14px;
        color: #2e4344;
        line-height: 20px;
      }
      .nopay-filter {
        filter: blur(10px);
      }
    }
  }

  .purchase-notes {
    width: 100%;
    float: left;
    .purchase-notes-title {
      font-size: 16px;
      color: #3c4130;
      line-height: 1.2;
      font-weight: 500;
    }
    .purchase-notes-des {
      margin-top: 8px;
      font-size: 14px;
      color: #2e4344;
      line-height: 20px;
    }
  }

  .footer-warp {
    position: fixed;
    padding: 0 20px 0 36px;
    bottom: 0px;
    width: 100%;
    height: 49px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // .heart-warp {
    //   padding: 4px, 0;
    //   display: flex;
    //   flex-direction: column;
    //   align-items: center;
    //   justify-content: space-between;
    //   .collect_blank {
    //     width: 22px;
    //     height: 22px;
    //     background: url($heart_blank) no-repeat;
    //     background-size: contain;
    //   }
    //   .collect_have {
    //     background: url($heart_have) no-repeat;
    //     background-size: contain;
    //   }
    // }

    .van-button {
      width: 300px;
      height: 40px;
      color: #ffffff !important;
      font-size: 16px;
      border: none;
      background: var(--btn-backgruond-color);
    }
  }
}
</style>
